import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { config } from '@app/core/app-config';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

export interface Currency {
  key: string;
}

@Injectable({
  providedIn: 'root',
})
export class CurrenciesService {
  private getCurrenciesUrl = `${config.API_URL}/currencies`;

  constructor(private http: HttpClient) {}

  // teamPropertiesOnly is used to get only the currencies that are used in team properties - rather than all possible currencies
  getCurrencies(currenciesForExistingPropertiesOnly = false): Observable<Currency[]> {
    const url = `${this.getCurrenciesUrl}?used_in_properties_only=${currenciesForExistingPropertiesOnly}`;

    return this.http.get(url).pipe(
      map((res: any) => {
        let data = res.data;

        data = data.filter((currency) => {
          return currency.key !== null;
        });

        return data.sort((a, b) => {
          if (a.key < b.key) {
            return -1;
          }
          if (a.key > b.key) {
            return 1;
          }
          return 0;
        });
      })
    );
  }
}
